import React from "react";
import { useTranslation } from "react-i18next";
import HeroSection from "../components/common/HeroSection";
import PageShell from "../components/common/PageShell";
import WelcomeSection from "../components/common/WelcomeSection";
import ImageTextRow from "../components/common/ImageTextRow";
import AboutValueCards from "../components/common/AboutValueCards";
import SectionHeader from "../components/common/SectionHeader";
import SectionThreeHomPage from "../components/home/SectionThreeHomPage";
import {
  MISSION_VISION_ROWS,
  ABOUT_EXTRA_ROWS,
} from "../constants/contentSections";
import { PAGE_HEROES } from "../constants/pageHeroes";

function About() {
  const { t } = useTranslation();

  return (
    <PageShell>
      <HeroSection {...PAGE_HEROES.about} variant="page" />
      <WelcomeSection>
        {[...MISSION_VISION_ROWS, ...ABOUT_EXTRA_ROWS].map((row) => (
          <ImageTextRow key={row.id} {...row} />
        ))}
        <section aria-labelledby="about-values-title">
          <SectionHeader
            titleId="about-values-title"
            eyebrow={t("High Quality Work")}
            title={t("Expert & Professional")}
            subtitle={t("Our products conform to standard specifications and are suitable for changing weather conditions")}
            className="pt-8"
          />
          <AboutValueCards className="caf-section__cards" />
        </section>
        <div className="h-16 sm:h-24" />
      </WelcomeSection>
      <SectionThreeHomPage />
    </PageShell>
  );
}

export default About;
